import { ACC_AUDITS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/acc_audits_actions';
import {
	compositeInitialStateGenerator,
	compositeReducerGenerator,
} from './standard_reducer_utils';

const initialState: any = compositeInitialStateGenerator(
	['accAuditsIndex'],
	['assetCycleCountRunId', 'assetId']
);
export default compositeReducerGenerator(CRUD_ACTION_CONSTANTS, initialState, [
	'assetCycleCountRunId',
	'assetId',
]);
